<template>
  <div class="d-flex flex-column align-items-center h-100 justify-content-center">
      <h1 class="text-primary" style="font-size: 50px">Accès refusé</h1>
      <p class="mt-4">Votre compte ne vous permet pas d'avoir accès à cette application</p>
      <p>
        Vous n'avez pas accès à cette application ibusiness, si vous pensez qu'il s'agit d'une erreur veuillez contacter votre direction.
      </p>
      <button
          @click="$router.push('/auth/login')"
          class="btn bt-challenges btn-secondary"
      >
        Retour à l’accueil
      </button>
  </div>
</template>

<script>

export default {
  name:"global_no_access",
    components:{
    },   
  data () {
    return {
    }
  },
  methods : {
  }
};
</script>
